export const STATUS_FILTERS = {
  OPEN: 'OPEN',
  OVERDUE: 'OVERDUE',
  ALL: 'ALL'
}

export const TIME_FRAME_FILTERS = {
  ALL: 'ALL',
  CUSTOM: 'CUSTOM'
}

export const TASKS_TYPES = {
  REVIEW: 'REVIEW',
  ACTION: 'ACTION',
  PERIOD: 'PERIOD',
  APPROVAL: 'APPROVAL'
}

export const TASK_COMPLETENESS = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL'
}
